//
// JS entry point
// ================================================================================

import { menu } from './menu.js';
import { quotes } from './quotes.js';
// import { revealAnimations } from './reveal-animations'; // Replaced by GSAP
import { scrollPosition } from './scroll-position';
import { initVideoPlayers } from './video.js';
import { initArrowScroll } from './arrow-scroll.js';
import { initDetailsLayout } from './details-layout.js';
import { initAnalyticsConsentDefaults, enableAnalytics, disableAnalytics, purgeAnalyticsScripts } from './analytics.js';
import { initCookieConsentBanner, initCookiesPolicyModal, shouldEnableAnalytics, getCookieConsent } from './cookie-consent.js';
import { initGSAP } from './gsap-init.js';
import { initGSAPModules } from './gsap/index.js';
import { initSorteoComponent } from './sorteo.js';
import { initTicketingComponent } from './ticketing.js';
import { initHorizontalScroll } from './gsap/horizontal-scroll.js';
import { initHeroVideoPlayback } from './hero-video.js';
import { isDesktopHorizontalScrollActive, isMobileVerticalScrollActive } from './scroll-mode.js';
import { initMobileVerticalScroll, finalizeMobileVerticalScroll } from './mobile-vertical.js';



function autorun(){
    const body = document.body;
    // Ocultar botones del navbar en desktop hasta que cargue el logo del hero (clase + regla inyectada)
    const isDesktop = body && window.matchMedia('(min-width: 1024px)').matches;
    const isHorizontal = body && body.classList.contains('horizontal-scroll-active');
    if (body && isHorizontal && isDesktop) {
        body.classList.add('hero-logo-not-loaded');
        const style = document.createElement('style');
        style.id = 'hero-logo-nav-hide';
        style.textContent = '@media (min-width:1024px){body.hero-logo-not-loaded .c-menu__nav .c-menu__anchor{visibility:hidden!important;opacity:0!important}}';
        (document.head || document.documentElement).appendChild(style);
    }

    // Parallax.js legacy: quitar atributos solo en desktop horizontal (en móvil los usan los dividers)
    if (body && isDesktopHorizontalScrollActive()) {
        document.querySelectorAll('[data-parallax]').forEach(el => {
            el.removeAttribute('data-parallax');
        });
    }

    if (isMobileVerticalScrollActive()) {
        initMobileVerticalScroll();
    }
    
    // Initialize GSAP first
    initGSAP();
    
    // Horizontal scroll solo en desktop (≥1024px)
    const isHorizontalActive = isDesktopHorizontalScrollActive();
    
    if (isHorizontalActive) {
        // Determine mode from data attribute on body or HTML structure
        const main = document.querySelector('.c-main');
        const bodyDataMode = body.getAttribute('data-scroll-mode');
        // For horizontal-snap, we should not have smooth-wrapper
        const hasSmoothWrapper = document.querySelector('#smooth-wrapper');
        
        // Force snap mode if data.json says horizontal-snap (even if HTML has old structure)
        // If bodyDataMode is null, check if smooth-wrapper exists to determine mode
        let mode;
        if (bodyDataMode === 'horizontal-snap') {
            mode = 'horizontal-snap'; // Force snap mode
            // Remove smooth-wrapper if it exists (old HTML structure)
            if (hasSmoothWrapper) {
                const wrapper = hasSmoothWrapper;
                const parent = wrapper.parentNode;
                while (wrapper.firstChild) {
                    parent.insertBefore(wrapper.firstChild, wrapper);
                }
                parent.removeChild(wrapper);
            }
        } else if (bodyDataMode === 'horizontal') {
            mode = 'horizontal';
        } else {
            // Fallback: use HTML structure to determine mode
            mode = hasSmoothWrapper ? 'horizontal' : 'horizontal-snap';
        }
        
        // Initialize horizontal scroll (should be initialized before other modules)
        initHorizontalScroll(mode);
    }
    
    // Initialize menu functionality
    menu();
    
    // Initialize GSAP modules based on variants
    initGSAPModules();

    if (isMobileVerticalScrollActive()) {
        finalizeMobileVerticalScroll();
    }
    
    // Other functionality
    // revealAnimations(); // Replaced by GSAP - commented out but kept for reference
    scrollPosition();
    initVideoPlayers();
    initArrowScroll();
    initDetailsLayout();

    initAnalyticsConsentDefaults();
    initCookieConsentBanner();
    initCookiesPolicyModal();

    const consent = getCookieConsent();
    if (consent !== 'accepted') {
        purgeAnalyticsScripts();
    }

    if (consent === 'accepted' || shouldEnableAnalytics()) {
        enableAnalytics();
    } else if (consent === 'rejected') {
        disableAnalytics();
    }

    window.addEventListener('cookieConsentChanged', (e) => {
        const v = e?.detail?.value;
        if (v === 'accepted') enableAnalytics();
        if (v === 'rejected') disableAnalytics();
    });

    initSorteoComponent();
    initTicketingComponent();
    initHeroVideoPlayback();
    
   
    console.log('Scripts Loaded!');
};

if (document.addEventListener) document.addEventListener("DOMContentLoaded", autorun, false);
else if (document.attachEvent) document.attachEvent("onreadystatechange", autorun);
else window.onload = autorun;
